import {
  Button,
  GridItem,
  SimpleGrid,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import Dropzone from '../../../components/dropzone/Dropzone';
import { boxName } from '../../../types/BoxName-type.enum';
import { useEffect, useState } from 'react';
import { useLazyQuery, useSubscription } from '@apollo/client';
import {
  GETALLLASTUPLOADED,
  LASTJOB,
  PROCESSFILES,
} from '../../../graphql/query';
import { SUBSCRIBE } from '../../../graphql/subscription';
import '../../../assets/css/Home.css';

export default function UserReports() {
  const [processing, setProcessing] = useState(false);
  const [allFiles, setAllFiles] = useState(false);
  const [raeeContainer, setRaeeContainer] = useState(null);
  const [errorBoxName, setErrorBoxName] = useState('');
  const [errorField, setErrorField] = useState<string[]>([]);
  // NEW: Keep track of the job state
  const [jobState, setJobState] = useState<string | null>(null);

  const toast = useToast();

  const [files] = useLazyQuery(GETALLLASTUPLOADED, {
    fetchPolicy: 'network-only',
  });
  const [process] = useLazyQuery(PROCESSFILES, { fetchPolicy: 'network-only' });
  const [lastJob] = useLazyQuery(LASTJOB, {
    fetchPolicy: 'network-only',
  });
  const { data, loading } = useSubscription(SUBSCRIBE);

  function errorUpload() {
    console.log('data', data);
    console.log('loading', loading);
  }

  async function countLastUploaded() {
    return await files();
  }

  async function runProcessFiles() {
    return await process();
  }

  async function getLastJob() {
    return await lastJob();
  }

  function setAllGreen() {
    setRaeeContainer('container-success');
  }

  function validationResult() {
    getLastJob().then((result) => {
      if (result.data) {
        const { state, errorField: missingFields } = result.data.getLastJob;

        // Save the job’s state in state
        setJobState(state);

        if (state === 'PROCESSING') {
          setProcessing(true);
        } else if (state === 'FAILED') {
          setAllGreen();
          setProcessing(false);
          setRaeeContainer('container-error');
          setErrorField(missingFields ?? []);
        } else if (state === 'SUCCESS') {
          setProcessing(false);
          setAllGreen();
        }
      }
    });
  }

  const processFiles = () => {
    runProcessFiles()
      .then(() => {
        setProcessing(false);
        toast({
          title: 'Data updated',
          status: 'success',
          duration: 1000,
          isClosable: false,
          onCloseComplete: () => {
            window.location.reload();
          },
        });
        window.location.reload();
      })
      .catch((e) => {
        console.error(e);
        toast({
          title: 'Error processing files',
          status: 'error',
          duration: 1000,
          isClosable: false,
          onCloseComplete: () => {
            window.location.reload();
          },
        });
      });
    test();
  };

  const checkUpdatedFiles = () => {
    countLastUploaded()
      .then((result) => {
        if (result.data.getAllLastUploaded.length === 1) {
          setAllFiles(false);
        } else {
          setAllFiles(true);
        }
      })
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    checkUpdatedFiles();
    validationResult();
  }, []);

  useEffect(() => {
    errorUpload();
    if (data) {
      setProcessing(false);
      validationResult();
      setErrorField([]);
      setErrorBoxName('');
    }
  }, [data, loading]);

  function test() {
    console.log('Data or loading changed.');
    errorUpload();
    if (data) {
      setProcessing(false);
      validationResult();
      setErrorField([]);
      setErrorBoxName('');
    }
  }

  // Chakra Color Mode
  if (!processing) {
    return (
      <SimpleGrid
        columns={1}
        gap={16}
        mx={{ base: 0, md: 32 }}
        mt={{ base: 0, md: 32 }}
      >
        <GridItem>
          <Dropzone
            boxName={boxName.raee}
            myFunction={checkUpdatedFiles}
            container={raeeContainer}
          />

          {/* Only show error if job state is FAILED */}
          {jobState === 'FAILED' && errorField?.length > 0 && (
            <div className="errorField">
              <b>MISSING THESE FIELDS:</b>
              <ul>
                {errorField.map((field, idx) => (
                  <li key={idx}>{field}</li>
                ))}
              </ul>
            </div>
          )}
        </GridItem>

        <GridItem>
          <Button
            colorScheme="purple"
            fontSize="sm"
            variant="brand"
            fontWeight="500"
            w="auto"
            h="50"
            mb="25px"
            mt="30px"
            isDisabled={allFiles}
            onClick={() => {
              setProcessing(true);
              processFiles();
            }}
          >
            Process uploaded files
          </Button>
        </GridItem>
      </SimpleGrid>
    );
  } else {
    return <Spinner position="relative" size="xl" className={'spinner'} />;
  }
}
